export const CustomFieldsRepository = Symbol.for('CustomFieldsRepository');
